import React from 'react'
import useDataLayer from 'src/hooks/useDataLayer/dataLayerBody'

import * as S from './style'
import ImageWebp from 'src/components/ImageWebp'

const DinheiroDeVoltaNoShopping = () => {
  const [ sendDatalayerEvent ] = useDataLayer()

  return (
    <S.ContentHeader className='pb-0 row justify-content-center align-items-center justify-content-md-start' role='img' aria-label='Tela de celular mostrando o Inter Shop'>
      <div className='col-12 col-md-6'>
        <h3 className='fs-24 lh-30 fs-lg-32 lh-lg-40 fs-xl-48 lh-xl-50 text-grayscale--500 fw-600 d-block mb-3'>
          Dinheiro de volta no Shopping
        </h3>
        <p className='fs-14 lh-17 fs-lg-16 lh-lg-20 fs-xl-18 lh-xl-22 fw-400 text-grayscale--400 mb-4'>
          Mais de 400 parceiros, as maiores lojas do Brasil, dezenas de categorias e cashback direto na sua conta.
        </p>
        <div className='d-none d-md-block btn-div'>
          <a
            href='https://shopping.bancointer.com.br/'
            target='_blank'
            rel='noreferrer'
            title='Visite o Inter Shop'
            className='btn btn--lg btn-orange--extra rounded-2 fs-14 fw-600 text-none mw-100'
            onClick={() => {
              sendDatalayerEvent({
                section: 'dobra_07',
                section_name: 'Mais que um banco digital, somos Inter!',
                element_action: 'click button',
                element_name: 'Visite o Inter Shop - Dinheiro de volta no Shopping',
                redirect_url: 'https://shopping.bancointer.com.br/',
              })
            }}
          >
            Visite o Inter Shop
          </a>
        </div>
      </div>
      <div className='col-12 col-md-6 col-lg-5 mb-4 mb-md-0 d-md-none'>
        <ImageWebp
          arrayNumbers={[ 340 ]}
          arrayNumbersHeight={[ 274 ]}
          pathSrc='https://central-imagens.bancointer.com.br/images-without-small-versions/investment-app-screen/image.webp'
          altDescription='Tela de celular mostrando o Inter Shop'
        />
      </div>
      <div className='col-12 col-md-6 col-lg-5 d-md-none'>
        <div className='btn-div'>
          <a
            href='https://shopping.bancointer.com.br/'
            target='_blank'
            rel='noreferrer'
            title='Visite o Inter Shop'
            className='btn btn--lg btn-orange--extra rounded-2 fs-14 fw-600 text-none mw-100'
            onClick={() => {
              sendDatalayerEvent({
                section: 'dobra_07',
                section_name: 'Mais que um banco digital, somos Inter!',
                element_action: 'click button',
                element_name: 'Visite o Inter Shop - Dinheiro de volta no Shopping',
                redirect_url: 'https://shopping.bancointer.com.br/',
              })
            }}
          >
            Visite o Inter Shop
          </a>
        </div>
      </div>
    </S.ContentHeader>
  )
}

export default DinheiroDeVoltaNoShopping
